import { apiORDS, urlORDS } from './api-functions'


export async function cidades(store, codmun, responseCallback) {
  let params = { id : codmun }
  var path = urlORDS(store, `nfse/cidade/`, params)
  const response = await apiORDS(path)
  if (response.data) {
    if (response.data.errmessages) {
      this.$erpToastError(response.data.errmessages[0])
      this.errmessages = {}
      this.errmessages.errmessages = response.data.errmessages
    } else {
      if (response.data > 0) {
        // this.$erpToastSuccess('Nota fiscal autorizada')
      }
      else {
        this.$erpToastError(response.data.xmotivo)
      }
    }
  }
  console.log(response)
  if (responseCallback) {
    responseCallback(response)
  }
}







// WEBPACK FOOTER //
// ./src/shared/nfse.js